import type { IconDef } from '../types';

export const minus: IconDef = {
  viewBox: '0 0 24 24',
  paths: [
    {
      d: 'M22 13H2C1.45 13 1 12.55 1 12C1 11.45 1.45 11 2 11H22C22.55 11 23 11.45 23 12C23 12.55 22.55 13 22 13Z',
    },
  ],
};
